/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actiontypes';

const initialState = {
  ar_smry_qtr_tbl: [],
  qtr_field_value: [],
  ar_smry_single_qtr: [],
  getQuarterValue: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actiontypes.AR_SUMMARY_QTR_TABLE:
      let getPgmVal = Object.keys(action.payload)[0];
      if (state.ar_smry_qtr_tbl.length != 0) {
        let main = state?.ar_smry_qtr_tbl?.forEach(function (obj) {
          delete obj[getPgmVal];
        });
      }
      return {
        ...state,
        ar_smry_qtr_tbl: [...state.ar_smry_qtr_tbl, action.payload],
      };
    case actiontypes.AR_SUMMARY_UNALLOCATED_QTR_TABLE:
      return {
        ...state,
        ar_smry_qtr_unallocated: action.getUnallocatedBlnQtrList,
      };
    case actiontypes.AR_SUMMARY_SINGLE_QTR_TABLE:
      let getAccRecPgmVal = Object.keys(action.getSingleAccRecQtrList)[0];
      if (state.ar_smry_single_qtr.length != 0) {
        let main = state?.ar_smry_single_qtr?.forEach(function (obj) {
          delete obj[getAccRecPgmVal];
        });
      }
      return {
        ...state,
        ar_smry_single_qtr: [
          ...state.ar_smry_single_qtr,
          action.getSingleAccRecQtrList,
        ],
      };
    case actiontypes.AR_SMRY_FOR_QTR_SINGLE:
      return { ...state, ar_smry_single_qtr_main: action.payload };
    case actiontypes.AR_SUMMARY_SINGLE_QTR_VALUE:
      let getAccRecPgmQtrVal = Object.keys(action.getQuarterValue)[0];
      if (state?.getQuarterValue?.length != 0) {
        let main = state?.getQuarterValue?.forEach(function (obj) {
          delete obj[getAccRecPgmQtrVal];
        });
      }
      return {
        ...state,
        getQuarterValue: [...state.getQuarterValue, action.getQuarterValue],
      };
    case actiontypes.SINGLE_FLD_DATA:
      let getPgmValSingle = Object.keys(action.payload)[0];
      if (state.qtr_field_value.length != 0) {
        let main = state?.qtr_field_value?.forEach(function (obj) {
          delete obj[getPgmValSingle];
        });
      }
      return {
        ...state,
        qtr_field_value: [...state.qtr_field_value, action.payload],
      };
    case actiontypes.AR_SUMMERY_QTR_FIELD_CLEAR_REDUX:
      return action.payload ? action.payload : {};
    default:
      return state;
  }
};

export default reducer;
